import React, { useState } from 'react';
import LandingScreen from './components/LandingScreen';
import ProcessingScreen from './components/ProcessingScreen';
import ResultsScreen from './components/ResultsScreen';
import { FALLBACK_DATA, DEFAULT_BRIEF } from './data/fallback';

export default function App() {
  const [screen, setScreen] = useState('landing');
  const [brief, setBrief] = useState(DEFAULT_BRIEF);
  const [results, setResults] = useState(null);
  const [isDemo, setIsDemo] = useState(false);

  const handleRunGTM = () => {
    setScreen('processing');
    setIsDemo(false);
  };

  const handleInstantDemo = () => {
    setScreen('processing');
    setIsDemo(true);
  };

  const handleResultsReady = (data) => {
    setResults(data);
    setScreen('results');
  };

  const handleReset = () => {
    setScreen('landing');
    setResults(null);
    setIsDemo(false);
  };

  return (
    <div className="min-h-screen bg-canvas text-ink font-sans">
      {screen === 'landing' && (
        <LandingScreen
          brief={brief}
          setBrief={setBrief}
          onRunGTM={handleRunGTM}
          onInstantDemo={handleInstantDemo}
        />
      )}
      {screen === 'processing' && (
        <ProcessingScreen
          isDemo={isDemo}
          brief={brief}
          onResultsReady={handleResultsReady}
          fallbackData={FALLBACK_DATA}
        />
      )}
      {screen === 'results' && results && (
        <ResultsScreen
          results={results}
          brief={brief}
          onReset={handleReset}
        />
      )}
    </div>
  );
}
